"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.howMuchWork = void 0;
const enums_1 = require("@bemlo/enums");
exports.howMuchWork = {
    [enums_1.HowMuchWorkAlternative.FULLTIME]: 'Heltid',
    [enums_1.HowMuchWorkAlternative.REGULAR_PART_TIME]: 'Deltid',
    [enums_1.HowMuchWorkAlternative.IRREGULAR_PART_TIME]: 'Tilkalling',
};
